import React from 'react';
import Select from '../../../components/ui/Select';
import Icon from '../../../components/AppIcon';

const PlayerSelection = ({ label, players, selectedPlayer, onSelect, disabled, description, error, required }) => {
  const playerOptions = players?.map(player => ({
    value: player?.id,
    label: `${player?.name} (${player?.team})`,
    description: player?.role
  }));

  return (
    <div className="space-y-2">
      <Select
        label={label}
        description={description}
        options={playerOptions}
        value={selectedPlayer}
        onChange={onSelect}
        disabled={disabled}
        searchable
        placeholder="Select a player"
        className="w-full"
        error={error}
        required={required}
      />
      {error && (
        <p className="flex items-center gap-1.5 text-xs text-destructive mt-1">
          <Icon name="AlertCircle" size={13} className="text-destructive flex-shrink-0" />
          {error}
        </p>
      )}
    </div>
  );
};

export default PlayerSelection;